/** Dependencies */
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Divider,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

/** Types */
import { BasketProduct } from '../../../../../../../models/Product';

/** Styles */
import styles from '../../styles';
import generalStyles from '../../../../../../../assets/stylesheets/generalStyles';
import getActiveLanguage from '../../../../../../../helpers/getActiveLanguage';
import { singlePriceFormatter } from '../../../../../../../helpers/moneyFormatter';

interface Props {
  list: BasketProduct[];
  currencyCode: string;
}

function PaidOrders({ list, currencyCode }: Props) {
  const { t } = useTranslation('pos');

  const paidOrders = () => {
    const paidList = list.map(
      item =>
        ((item.paid_quantity && !item.selected_orders_count) ||
          item.is_treat) && (
          <>
            <br />
            <Divider />
            <br />
            <Stack direction="row">
              <Paper sx={generalStyles.orderCountContainer}>
                <Typography>{item.paid_quantity || item.count}</Typography>
              </Paper>
              <Stack
                sx={{ flex: 1, pl: 2, cursor: 'pointer' }}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box>
                  <Typography sx={styles.selectedQuantityInfo}>
                    {item.paid_quantity || item.count} {t('paymentModal.piece')}
                  </Typography>
                  <Typography
                    sx={{ ...styles.title, textDecoration: 'line-through' }}
                  >
                    {item?.product?.translations
                      ? getActiveLanguage(item?.product?.translations)?.name
                      : item?.translations
                      ? getActiveLanguage(item?.translations)?.name
                      : item.items[0].product_name}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ ...styles.title, textDecoration: 'line-through' }}
                  >
                    {item.units &&
                      getActiveLanguage(item.units[0].translations).name}
                  </Typography>
                  {item.is_treat && (
                    <Typography sx={styles.properties} variant="subtitle2">
                      <List>
                        İndirim miktarı:{' '}
                        {singlePriceFormatter(
                          item.total_amount.amount,
                          1,
                          currencyCode,
                        )}
                      </List>
                    </Typography>
                  )}
                  <Typography sx={styles.properties} variant="subtitle2">
                    <List>
                      {item.items.length &&
                        item.items?.map(
                          itemItems =>
                            itemItems.property_group_items &&
                            itemItems.property_group_items.map(propItem => (
                              <ListItem sx={styles.priceInfo}>
                                {propItem.translations[0].name}
                                {propItem.additional_price.amount !== '0' &&
                                  ` + ${propItem.additional_price.formatted}`}
                              </ListItem>
                            )),
                        )}
                    </List>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography
                    sx={{ ...styles.title, textDecoration: 'line-through' }}
                  >
                    {!item.is_treat
                      ? singlePriceFormatter(
                          item.total_amount.amount,
                          item.paid_quantity / item.count,
                          currencyCode,
                        )
                      : 'İkram'}
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          </>
        ),
    );
    return paidList.filter(item => !!item);
  };

  return (
    <>
      {paidOrders().length > 0 && (
        <>
          <Stack
            sx={{
              textDecoration: 'underline 1.5px red',
              textUnderlinePosition: 'under',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            {t('paymentModal.payer')}
          </Stack>
          <br />
        </>
      )}
      <Stack direction="column-reverse">{paidOrders()}</Stack>
    </>
  );
}

export default PaidOrders;
